import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M5.49545 21.8682C4.67768 22.3357 3.72653 21.5158 4.06791 20.6376L11.065 2.63755C11.3954 1.78748 12.5978 1.78748 12.9282 2.63755L19.9253 20.6376C20.2666 21.5158 19.3155 22.3357 18.4977 21.8682L11.9966 18.1518L5.49545 21.8682ZM11.9966 5.75903L6.95409 18.7309L11.5007 16.1318C11.808 15.9561 12.1852 15.9561 12.4925 16.1318L17.0391 18.7309L11.9966 5.75903Z" />,
  'Navigation'
);
